import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import PersonIcon from '@material-ui/icons/Person';
import blue from '@material-ui/core/colors/blue';

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);

const BorrowerMetricTooltip = (props) => {
    return (
        <div style={{display:"flex"}}>
          <HtmlTooltip interactive={true}
            title={
              <React.Fragment>
                <Typography color="inherit"><b><u>Borrower Details</u></b></Typography>
                <p><b>Name: </b>{props.borrowerName}</p>
                <p><b>Credit Score: </b>{props.borrowerCreditScore}</p>
                <p><b>Employer: </b>{props.borrowerEmployer}</p>
                {props.borrowerAddress ? 
                (<p><b>Address: </b>{props.borrowerAddress}</p>) : null}
                <p><b>DTI: </b>{props.borrowerDTI}</p>
                <p><b>Income: </b>{props.borrowerIncome}</p>
                {props.borrowerOccupation ? <p><b>Occupation: </b>{props.borrowerOccupation}</p> : null}
                {props.coborrowerCreditScore ? 
                <React.Fragment>
                  <Typography color="inherit"><b><u>Coborrower Details</u></b></Typography>
                  <p><b>Name: </b>{props.coborrowerName}</p>
                  <p><b>Credit Score: </b>{props.coborrowerCreditScore}</p>
                  <p><b>Employer: </b>{props.coborrowerEmployer}</p>
                  {props.coborrowerOccupation ? <p><b>Occupation: </b>{props.coborrowerOccupation}</p> : null}
                </React.Fragment>
                : ''}
              </React.Fragment>
            }
          >
            <IconButton component="span">
                <PersonIcon style={{ color: blue[700] }} />
            </IconButton>
          </HtmlTooltip>
        </div>
      );
}

BorrowerMetricTooltip.propTypes = {
  borrowerName: PropTypes.string,
  borrowerCreditScore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borrowerEmployer: PropTypes.string,
  borrowerAddress: PropTypes.string,
  borrowerDTI: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borrowerIncome: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borrowerOccupation: PropTypes.string,
  coborrowerName: PropTypes.string,
  coborrowerCreditScore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  coborrowerEmployer: PropTypes.string,
  coborrowerOccupation: PropTypes.string,
};

export default BorrowerMetricTooltip;